import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import {
    LOADING,
    LOAD_CHARGE_TYPE_MAPPINGS_SUCCESS,
    UPDATE_CHARGE_TYPE_MAPPINGS_SUCCESS,
    CLEAR_CHARGE_TYPE_MAPPINGS,
    LOAD_POS_CHARGE_TYPES_SUCCESS,
    IMPORT_POS_CHARGE_TYPES_SUCCESS
} from '../../../types';
import MessageUtils from '../../../../utils/MessageUtils';

export const loadChargeTypeMappings = (restaurantId) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant/${restaurantId}/charge-type-mappings`;

            axios().get(url)
                .then(response => loadChargeTypesSuccess(dispatch, response.data))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:chargeTypeMapping.loadChargeTypeFailure')));
        }
    };
};

const loadChargeTypesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CHARGE_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const loadPosChargeTypes = (restaurantId) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });
            const url = `/restaurant/${restaurantId}/pos-charge-types`;

            axios().get(url)
                .then(response => loadPosChargeTypesSuccess(dispatch, response.data))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:chargeTypeMapping.loadPosChargeTypeFailure')));
        }
    };
};

const loadPosChargeTypesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_POS_CHARGE_TYPES_SUCCESS, payload: response });
};

// just added
export const updateChargeTypeMappings = (state, restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/charge-type-mappings`;
        const chargeTypeMappings = [];

        state.map(currentMapping => {
            if (currentMapping.posChargeType.id == -1) {
                const sanitizedMapping = {
                    id: currentMapping.id,
                    chargeType: {
                        id: currentMapping.chargeType.id,
                        value: currentMapping.chargeType.value
                    },
                    posChargeType: null
                }
                chargeTypeMappings.push(sanitizedMapping);

            } else {
                chargeTypeMappings.push(currentMapping);
            }
        });

        axios().put(url, chargeTypeMappings)
            .then(response => updateChargeTypeMappingsSuccess(dispatch, getState, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateChargeTypeMappingsSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_CHARGE_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const clearChargeTypeMappings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_CHARGE_TYPE_MAPPINGS });
    }
}

export const importPosChargeTypes = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-pos-charge-types`;

        axios().get(url)
            .then(response => importPosChargeTypesSuccess(dispatch, response, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:chargeTypeMapping.importPosFailure')));
    }
}

const importPosChargeTypesSuccess = (dispatch, response, restaurantId) => {
    dispatch({ type: IMPORT_POS_CHARGE_TYPES_SUCCESS, payload: response });

    const url = `/restaurant/${restaurantId}/pos-charge-types`;

    axios().get(url)
        .then(response => loadPosChargeTypesSuccess(dispatch, response, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:chargeTypeMapping.loadPosChargeTypeFailure')));
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/pos/ChargeTypeMappingActions.js